export default __webpack_public_path__ + "static/media/r-overlay2.0cd0bd87.png";